import React from 'react';

const ExitIcon = ({ color="#212121", ...rest }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M9.69531 9.00049L22.7179 22.023" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M9.69531 21.9995L22.7179 8.97696" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M9.69531 9.00049L22.7179 22.023" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>

  );
};

export default ExitIcon;